import React from 'react';
import Loader from './Loader';

const BtnStandard = ({label,size="s",click,load=false}) => {
    return (
       <button onClick={()=>click&& click()} className={`btn btn-standard df jcc aic fr ${size}`}>
        {load ? <Loader/> : (
            label
        )}
        </button>
    );
};

export default BtnStandard;